import i18nHelper from "../../../core/services/i18n.service"
import http from "../../../core/services/http.service";
import {Formatter} from "@/core/services/formatter.service";

export default {
  getCategories(params = null) {
    return http.get('/api/v1/categories/', {params});
  },
  getCategory(uuid, params = null) {
    return http.get(`/api/v1/categories/${uuid}/`, {params});
  },
  updateCategory(id, data) {
    return http.put(`/api/v1/categories/${id}/`, data);
  },
  createCategory(data) {
    return http.post('/api/v1/categories/', data);
  },
  removeCategory(uuid) {
    return http.delete(`/api/v1/categories/${uuid}`)
  },
  getCategoryBulkEditFields(uuids) {
    return http.get(`/api/v1/categories/bulk-edit-fields`, {params: {uuids: uuids}})
  },
  iterate(current, flattenedCategoriesArr) {
    let children = current.children || [];

    current.text = Formatter.getByMasterLanguage(current.name);
    current.data = {};
    current.data.checked = false;
    current.id = current.uuid;
    flattenedCategoriesArr.push(current);

    for (let i = 0, len = children.length; i < len; i++) {
      this.iterate(children[i], flattenedCategoriesArr);
    }
  },
  prepareDataForTree(current, expandedNodeIds = []) {
    let children = current.children || [];

    current.children = current.children === undefined ? [] : current.children;
    current.text = Formatter.getByMasterLanguage(current.name);
    current.data = {};
    current.data.checked = false;
    current.id = current.uuid;

    if (expandedNodeIds.includes(current.id)) {
      current.state = {expanded: true};
    }

    for (let i = 0, len = children.length; i < len; i++) {
      this.prepareDataForTree(children[i], expandedNodeIds);
    }
  },
  expandUpper(node) {
    if (node.parent) {
      node.parent.expand();
      return this.expandUpper(node.parent);
    }
  }
};
